<div
  class="button-with-label"
  [ngClass]="{
    'reduced-style': reduced && !isTicketContext,
    'reduced-ticket-style': reduced && isTicketContext,
    'status-invert-ticket': isTicketContext && topic === 'status'
  }"
>
  <span class="button-label">{{ label | translate }}</span>
  <button
    mat-icon-button
    [ngClass]="{
      'no-selection': status === 0,
      'in-progress': status === 1,
      selected: status === 2
    }"
    (click)="onDependentClick()"
    [disabled]="disabled"
  >
    <ng-container *ngIf="status === 0">
      <mat-icon
        [style.color]="selectedColor"
        [style.background-color]="selectedBackgroundColor"
        >{{ icon }}</mat-icon
      >
      <mat-icon
        *ngIf="selectedImportance > 1"
        [style.color]="selectedColor"
        [style.background-color]="selectedBackgroundColor"
        >{{ icon }}</mat-icon
      >
      <mat-icon
        *ngIf="selectedImportance > 2"
        [style.color]="selectedColor"
        [style.background-color]="selectedBackgroundColor"
        >{{ icon }}</mat-icon
      >
      <mat-icon
        *ngIf="selectedImportance > 3"
        [style.color]="selectedColor"
        [style.background-color]="selectedBackgroundColor"
        >{{ icon }}</mat-icon
      >
      <mat-icon
        *ngIf="selectedImportance > 4"
        [style.color]="selectedColor"
        [style.background-color]="selectedBackgroundColor"
        >{{ icon }}</mat-icon
      >
    </ng-container>
    <ng-container *ngIf="status === 1">
      <mat-icon [style.color]="selectedColor" class="coloredcircle"
        >hourglass_empty</mat-icon
      >
    </ng-container>
    <ng-container *ngIf="status === 2">
      <span>{{ selectedImportance }}</span>
      <mat-icon [style.color]="selectedColor">{{ icon }}</mat-icon>
    </ng-container>
  </button>
  <ng-container *ngIf="showLabel">
    <p class="label">
      {{
        topic === "branches" || topic === "departments"
          ? (selectedLabel | slice : 0 : 8)
          : selectedLabel
      }}
    </p>
  </ng-container>
</div>
